export const paramTable_dialog = "PARAMTABLE_DIALOG";
export const graphIntervals_dialog = "GRAPHINTERVALS_DIALOG";
export const medicalReport_dialog = "MEDICALREPORT_DIALOG";
export const chooseCmpx_dialog = "CHOOSECMPX_DIALOG";
export const measurer_dialog = "MEASURER_DIALOG";
export const wait_dialog = "WAIT_DIALOG";
export const aim_dialog = "AIM_DIALOG";
